/**
 * Asset types used for displaying a strong asset type.
 * @remark This is different from a asset observable type.
 */
export const AssetSubtypes = {
  Application: "application",
  Data: "data",
  Device: "device",
  Email: "email",
  Endpoint: "endpoint",
  EndpointSensor: "endpoint.sensor",
  EndpointServer: "endpoint.server",
  Network: "network",
  NetworkFirewall: "network.firewall",
  NetworkGateway: "network.gateway",
  Person: "person",
  ProcessEmailService: "process.email-service",
  User: "user"
};

/**
 * Display values for @constant AssetsSubtypes
 */
export const AssetSubtypeLabels = {
  [AssetSubtypes.Application]: "Application",
  [AssetSubtypes.Data]: "Data",
  [AssetSubtypes.Device]: "Device",
  [AssetSubtypes.Email]: "Email",
  [AssetSubtypes.EndpointSensor]: "Endpoint Sensor",
  [AssetSubtypes.EndpointServer]: "Endpoint Server",
  [AssetSubtypes.Endpoint]: "Endpoint",
  [AssetSubtypes.NetworkFirewall]: "Network Firewall",
  [AssetSubtypes.NetworkGateway]: "Network Gateway",
  [AssetSubtypes.Network]: "Network",
  [AssetSubtypes.Person]: "Person",
  [AssetSubtypes.ProcessEmailService]: "Email Service",
  [AssetSubtypes.User]: "User"
};

/**
 * Returns a human readable asset type (aka subtype in engine.getAssets)
 *
 * @param {string} type Asset type
 * @returns {string} Human readable display value
 */
export const getAssetDisplayType = (type) =>
  Object.values(AssetSubtypes).includes(type) ? AssetSubtypeLabels[type] : type;
